/* eslint-disable react/prop-types */
import React from "react";
//Packages
import { Row, Col, Form, Button } from "react-bootstrap";

const FilterMenu = (props) => {
  // Reset all the filters
  const onResetFilter = () => {
    props.setFilterDay("");
    props.setFilterTutor("");
    props.setFilterAvailableClasses("");
    props.setFilterLessonType("");
    props.setFilterVenue("");
    sessionStorage.removeItem("filterVenue");
    sessionStorage.removeItem("filterDay");
    sessionStorage.removeItem("filterLessonType");
    sessionStorage.removeItem("filterTutor");
    return sessionStorage.removeItem("filterAvailableClasses");
  };
  // Filter by Venue
  const onVenueChange = (e) => {
    props.setFilterVenue(e.target.value);
    return sessionStorage.setItem("filterVenue", JSON.stringify(e.target.value));
  };
  //Filter by Day
  const onDayChange = (e) => {
    props.setFilterDay(e.target.value);
    return sessionStorage.setItem("filterDay", JSON.stringify(e.target.value));
  };
  // Filter by LessonType
  const onLessonTypeChange = (e) => {
    props.setFilterLessonType(e.target.value);
    return sessionStorage.setItem("filterLessonType", JSON.stringify(e.target.value));
  };
  // Filter by Tutor
  const onTutorChange = (e) => {
    props.setFilterTutor(e.target.value);
    return sessionStorage.setItem("filterTutor", JSON.stringify(e.target.value));
  };
  // Filter by Available
  const onFilterAvailableClasses = () => {
    let newState;
    if (props.filterAvailableClasses === "true") {
      newState = "false";
    } else {
      newState = "true";
    }
    props.setFilterAvailableClasses(newState);
    return sessionStorage.setItem("filterAvailableClasses", JSON.stringify(newState));
  };

  return (
    <>
      <Row className='shadow-element pb-4 prominentBox'>
        <Col sm='6' lg='3'>
          <Form className='Venue mt-3'>
            <Form.Label>Venue</Form.Label>
            <Form.Control
              as='select'
              value={props.filterVenue}
              onChange={onVenueChange}
              custom
              className='border'
            >
              <option value=''>Any Venue</option>
              {props.Venues.map((Venue) => (
                <option key={Venue} value={Venue}>
                  {Venue}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col sm='6' lg='3'>
          <Form className='Venue mt-3'>
            <Form.Label>Day</Form.Label>
            <Form.Control
              as='select'
              value={props.filterDay}
              onChange={onDayChange}
              custom
              className='border'
            >
              <option value=''>Any Day</option>
              <option value='Monday'>Monday</option>
              <option value='Tuesday'>Tuesday</option>
              <option value='Wednesday'>Wednesday</option>
              <option value='Thursday'>Thursday</option>
              <option value='Friday'>Friday</option>
              <option value='Saturday'>Saturday</option>
              <option value='Sunday'>Sunday</option>
            </Form.Control>
          </Form>
        </Col>
        <Col sm='6' lg='3'>
          <Form className='Venue mt-3'>
            <Form.Label>Type</Form.Label>
            <Form.Control
              as='select'
              value={props.filterLessonType}
              onChange={onLessonTypeChange}
              custom
              className='border'
            >
              <option value=''>Any Type</option>
              {props.LessonTypes.map((LessonType) => (
                <option key={LessonType} value={LessonType}>
                  {LessonType}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col sm='6' lg='3'>
          <Form className='Venue mt-3'>
            <Form.Label>Tutor</Form.Label>
            <Form.Control
              as='select'
              value={props.filterTutor}
              onChange={onTutorChange}
              custom
              className='border'
            >
              <option value=''>Any Tutor</option>
              {props.Tutors.map((Tutor) => (
                <option key={Tutor} value={Tutor}>
                  {Tutor}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col sm='12' lg='12' className='d-inline-flex justify-content-center align-items-center'>
          <Form className='Venue mt-3'>
            <Form.Check
              type='checkbox'
              label='Spaces Available'
              onChange={onFilterAvailableClasses}
              checked={props.filterAvailableClasses === "true"}
            />
          </Form>
        </Col>
        <Col sm='12' lg='12' className='d-inline-flex justify-content-center align-items-center'>
          <Button
            variant='secondary'
            size='sm'
            type='button'
            className='mt-2'
            onClick={onResetFilter}
          >
            clear
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default FilterMenu;
